export enum FlightTabResultListEnum {
  FLIGHT = 0,
  PRICE = 1,
  POLICY = 2,
  FLIGHTDISPLAY = "flight-detail",
  PRICEDISPLAY = "price-detail",
  POLICYDISPLAY = "policy",
}
export enum FlightLegEnum {
  LEGDEPARTURE = "Departure",
  LEGRETURN = "Return",
  LEGOUTWARD = "Outward",
}

export enum FlightType {
  DOMESTIC = "domestic",
  INTERNATIONAL = "international",
  ALL = "all",
}

export enum FlightTravel {
  ROUNDTRIP = "roundtrip",
  SINGLETRIP = "single",
  MULTITRIP = "multitrip",
}
